import { RouteGetCdtCategories_categoryId_Tree } from "@CommonApi/cdt/categories/_categoryId_/tree";
import type { ResponseGetCdtCategoryTree } from "@CommonApi/cdt/categories/_categoryId_/tree";
import { RouteGetCdtTrees_treeId_ } from "@CommonApi/cdt/trees/_treeId_/index";
import type { ResponseGetCdtTree } from "@CommonApi/cdt/trees/_treeId_/index";
import { RoutePutCdtTrees_treeId_ } from "@CommonApi/cdt/trees/_treeId_/put";
import type { PutCdtTree } from "@CommonApi/cdt/trees/_treeId_/put";
import { RouteGetCdtTrees_treeId_Items } from "@CommonApi/cdt/trees/_treeId_/items";
import { QueryGetCdtTreeItemsSchema } from "@CommonApi/cdt/trees/_treeId_/items";
import type {
  QueryGetCdtTreeItems,
  QueryGetCdtTreeItemsInput,
  ResponseGetCdtTreeItems,
} from "@CommonApi/cdt/trees/_treeId_/items";
import { RoutePostCdtTrees_treeId_Reset } from "@CommonApi/cdt/trees/_treeId_/reset";
import type { ResponsePostCdtTrees_treeId_Reset } from "@CommonApi/cdt/trees/_treeId_/reset";
import { API, getRequest, putRequest, postRequest } from "src/utils/axios";

export const fetchCdtCategoryTree = async (
  categoryId: number,
): Promise<ResponseGetCdtCategoryTree> => {
  const url = `${API}${RouteGetCdtCategories_categoryId_Tree.replace(":categoryId", categoryId.toString())}`;
  const { data } = await getRequest<ResponseGetCdtCategoryTree>(url);
  return data;
};

export const fetchCdtTree = async (treeId: number): Promise<ResponseGetCdtTree> => {
  const url = `${API}${RouteGetCdtTrees_treeId_.replace(":treeId", treeId.toString())}`;
  const { data } = await getRequest<ResponseGetCdtTree>(url);
  return data;
};

export const putCdtTree = async (
  treeId: number,
  payload: PutCdtTree,
): Promise<ResponseGetCdtTree> => {
  const url = `${API}${RoutePutCdtTrees_treeId_.replace(":treeId", treeId.toString())}`;
  const { data } = await putRequest<ResponseGetCdtTree>(url, { payload });
  return data;
};

export const normalizeCdtTreeItemsQuery = (
  input: QueryGetCdtTreeItemsInput,
): QueryGetCdtTreeItems => {
  const normalized = QueryGetCdtTreeItemsSchema.parse(input);

  return {
    ...(normalized.nodeId !== undefined ? { nodeId: normalized.nodeId } : {}),
    ...(normalized.unassigned !== undefined ? { unassigned: normalized.unassigned } : {}),
    ...(normalized.search !== undefined ? { search: normalized.search } : {}),
    page: normalized.page,
    size: normalized.size,
  };
};

export const fetchCdtTreeItems = async (
  treeId: number,
  input: QueryGetCdtTreeItemsInput,
): Promise<ResponseGetCdtTreeItems> => {
  const queryParams = normalizeCdtTreeItemsQuery(input);
  const url = `${API}${RouteGetCdtTrees_treeId_Items.replace(":treeId", treeId.toString())}`;
  const { data } = await getRequest<ResponseGetCdtTreeItems>(url, { queryParams });
  return data;
};

export const postResetCdtTree = async (
  treeId: number,
): Promise<ResponsePostCdtTrees_treeId_Reset> => {
  const url = `${API}${RoutePostCdtTrees_treeId_Reset.replace(":treeId", treeId.toString())}`;
  const { data } = await postRequest<ResponsePostCdtTrees_treeId_Reset>(url);
  return data;
};
